/* global PipeSDK, chrome */

const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {assessments} assessments the resource defined to manage assessments
 */
app.directive('fileQuestionPresenter', ['Application', 'AssessmentLib', 'S3Uploads', 'Upload', '$translate', function(Application, AssessmentLib, S3Uploads, Upload, $translate) {
    return {
      restrict: 'E',
      scope: {
        question: '=',
        userResponses: '=',
        onResponse: '&',
        description: '=?'
      },
      template: require('../../../templates/directives/assessments/file-question-presenter.html'),
      controller: ['$scope', '$window', function($scope, $window) {
          var self = this;
          self.submitting = false;
          self.description = $scope.description;
          self.translations = {};
          self.lightboxStatus = false;
          self.lightboxUrl = '';

          var options = ['pdf', 'doc', 'xls', 'jpeg', 'png'];
          var acceptMap = {
            pdf: 'application/pdf',
            doc: '.txt,.doc,.docx',
            xls: 'application/excel,application/vnd.ms-excel,application/vnd.msexcel,.xls,.xlsx',
            jpeg: 'image/jpeg',
            png: 'image/png'
          };

          self.accept = "";

          self.fileName;
          self.uploaderId = 'assessment-upload';

          self.browseFile = function() {
            document.getElementById(self.uploaderId).click();
          };

          $scope.$watch('filePresenter.uploadedFile', function(newVal, oldVal) {
            if(newVal && !newVal.$error) {
              self.onFileSelect(self.uploadedFile);
            }
          });


          self.onFileSelect = function(uploaded) {
            self.fileName = uploaded.name;
            if(uploaded.size > 500000000) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.exceed_limit_500'], duration: 5});
              return;
            }
            if(uploaded.type === '') {
              uploaded.type = 'application/octet-stream';
            }

            S3Uploads.filePolicy({fileName: uploaded.name, contentType: uploaded.type}, function(data) {
              var cloudFrontLink = data.CloudFrontLink;
              Upload.upload({
                url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                headers: {'Remove-auth': 'yes'},
                method: 'POST',
                data: {
                  key: data.Key,
                  'Content-Type': data.ContentType,
                  AWSAccessKeyId: data.AWSAccessKeyId,
                  'success_action_status': '201',
                  policy: data.S3Policy,
                  signature: data.S3Signature
                },
                file: uploaded
              }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                self.loadingBar = true;
                self.loadingPercent = percent;
                self.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
              }).success(function(data) {
                self.loadingBar = false;
                self.uploadedLink = cloudFrontLink;
              }).catch(function(error) {
                console.log('upload error', error);
              });
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });

          };

          self.reset = function() {
            self.fileName = '';
            self.uploadedLink = null;
            self.uploadedFile = null;
            self.loadingPercent = 0;
          };

          self.submit = function() {
            if (!self.uploadedLink) {
              return;
            }
            self.submitting = true;
            if ($scope.userResponses[$scope.question.id]) {
              $scope.userResponses[$scope.question.id].unshift({link: self.uploadedLink, title: self.fileName});
            } else {
              $scope.userResponses[$scope.question.id] = [{link: self.uploadedLink, title: self.fileName}];
            }
            $scope.onResponse({submit: true});
          };

          self.info = {
            settings: {},
            previous_links: [],
            selected_link: null,
            parse: function() {
              self.info.settings = AssessmentLib.helpers.getQuestionOptions($scope.question);
            },
            save: function(link) {
              clearInterval(self.info.interval_id);
              clearInterval(self.keep_active_interval_id);
              if ($scope.userResponses[$scope.question.id]) {
                $scope.userResponses[$scope.question.id].unshift(link);
              } else {
                $scope.userResponses[$scope.question.id] = [link];
              }
              $scope.onResponse();
            }
          };

          self.info.parse();
          self.uploads = self.info.settings.upload_type ? self.info.settings.upload_type.split(',') : [];
          self.uploadString = self.uploads.join(', ');

          self.accept = '';
          options.forEach(function(opt) {
            if (self.uploads.indexOf(opt) !== -1 && acceptMap[opt]) {
              if (self.accept) {
                self.accept += ',';
              }
              self.accept += acceptMap[opt];
            }
          });

          $translate([
            'vidQuestionPres.leave_confirm'
          ]).then(function (translations) {
            self.translations = translations;
          });

        }],
      controllerAs: 'filePresenter'
    };
  }]);
